module.exports = __webpack_public_path__ + "img/ios-shirt.bd6ff6e1.svg";